import React from 'react';
import {createStackNavigator, StackScreenProps} from '@react-navigation/stack';

import {Screens, Routes} from './model';
import {ProfileNotificationSettings} from '../../screens/profile/mobile/components/notifications';
import {ProfileMobile} from '../../screens/profile/mobile';
import {DesktopProfileSettings} from '../../screens/profile/desktop/components/settings';
import {ProfileUserDocuments} from '../../screens/profile/mobile/components/documents';
import {ProfileUserContacts} from '../../screens/profile/mobile/components/contacts';
import {ProfileApplications} from '../../screens/profile/common/applications';
import {ProfileChangePassword} from '../../screens/profile/common/changePassword';
import {ProfileBaseInfo} from '../../screens/profile/mobile/components/baseInfo';
import {useTheme} from '../theme';
import {ProfileScreen} from '../../screens/profile';
import {ProfileApplicationsItemMobile} from '../../screens/profile/mobile/components/applications/item';
import {ProfileApplicationsItemResolver, ProfileApplicationsResolver} from '../resolvers/applications';
import {createRootScreenOptions, createProfileChildScreenOptions} from './topBar';
import {ProfileApplicationsFilterMobile} from '../../screens/profile/mobile/components/applicationsFilter';
import {ProfileUserPhoneConfirmation} from '../../screens/profile/mobile/components/phoneConfirmation';
import {ProfileUserEmailConfirmation} from '../../screens/profile/mobile/components/emailConfirmation';
import {ProfileSafety} from '../../screens/profile/mobile/components/safety';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../redux/selectors/profile';
import {UscType} from '../models/profile/uscType';
import {TouchableOpacity, View} from 'react-native';
import {images} from '../../assets/icons';
import {useStyles} from '../hooks/styles';
import {Settings} from '../constants/config';

const MobileStack = createStackNavigator();
export const MobileProfileNavigation = (props: StackScreenProps<any>) => {
  const holderProfile = useSelector(holderProfileSelector());
  const theme = useTheme();
  const styles = useStyles(() => {
    return {
      rightContainer: {
        color: theme.color.labelText,
        borderWidth: 2,
        borderColor: theme.color.labelText,
        width: 36,
        height: 36,
        borderRadius: 18,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 6,
      },
      rightColor: {
        color: theme.color.labelText,
      },
    };
  });
  return (
    <MobileStack.Navigator initialRouteName={Screens.ProfileMenu}>
      <MobileStack.Screen
        options={createRootScreenOptions(
          theme,
          `Мой профиль${Settings.getIsTest() ? '(Тестовый)' : ''}`,
          props.navigation,
          true,
        )}
        name={Screens.ProfileMenu}
        component={ProfileMobile}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Общая информация')}
        name={Screens.ProfileBaseInfo}
        component={ProfileBaseInfo}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Документы')}
        name={Screens.ProfileUserDocuments}
        component={ProfileUserDocuments}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Контактные данные')}
        name={Screens.ProfileConfirmation}
        component={ProfileUserContacts}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Контактные данные')}
        name={Screens.ProfileUserContacts}
        component={ProfileUserContacts}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Подтвердите новый номер')}
        name={Screens.ProfileUserPhoneConfirmation}
        component={ProfileUserPhoneConfirmation}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Подтвердите нову. эл. почту')}
        name={Screens.ProfileUserEmailConfirmation}
        component={ProfileUserEmailConfirmation}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Фильтр', Screens.ProfileApplications, () => {
          return (
            <TouchableOpacity
              testID='profile-applications-id'
              onPress={() => {
                props.navigation.navigate(Screens.ProfileApplications);
              }}>
              <View style={styles.rightContainer as any}>
                <images.Check color={styles.rightColor.color} height={24} width={24} />
              </View>
            </TouchableOpacity>
          );
        })}
        name={Screens.ProfileApplicationsFilter}
        component={ProfileApplicationsFilterMobile}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Просмотр заявлений')}
        name={Screens.ProfileApplications}
        component={ProfileApplicationsResolver(ProfileApplications)}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Заявление', Screens.ProfileApplications)}
        name={Screens.ProfileApplicationsItem}
        component={ProfileApplicationsItemResolver(ProfileApplicationsItemMobile)}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Настройка уведомлений')}
        name={Screens.ProfileNotificationSettings}
        component={ProfileNotificationSettings}
      />
      <MobileStack.Screen
        options={createProfileChildScreenOptions(theme, 'Изменение пароля')}
        name={Screens.ProfileChangePassword}
        component={ProfileChangePassword}
      />
      {holderProfile?.uscType === UscType.NonFinancial && (
        <MobileStack.Screen
          options={createProfileChildScreenOptions(theme, 'Безопасность')}
          name={Screens.ProfileSafety}
          component={ProfileSafety}
        />
      )}
    </MobileStack.Navigator>
  );
};

const ProfileRedirect = ({navigation}: StackScreenProps<any>) => {
  React.useEffect(() => navigation.navigate(Screens.DesktopProfileMe), []);
  return null;
};

export const desktopRoutes = [
  {
    route: Screens.Profile,
    webRoute: Routes.profile,
    component: ProfileRedirect,
  },
  {
    title: `Профиль${Settings.getIsTest() ? '(Тестовый)' : ''}`,
    route: Screens.DesktopProfileMe,
    webRoute: Routes.profileMe,
    component: ProfileScreen,
  },
  {
    title: 'Настройки',
    route: Screens.DesktopProfileSettings,
    webRoute: Routes.profileSettings,
    component: DesktopProfileSettings,
  },
  {
    title: 'Настройки',
    route: Screens.ProfileConfirmation,
    webRoute: Routes.profileConfirmation,
    component: DesktopProfileSettings,
  },
  {
    title: 'Изменение пароля',
    route: Screens.ProfileChangePassword,
    webRoute: Routes.profileChangePassword,
    component: ProfileChangePassword,
  },
  {
    route: Screens.ProfileApplications,
    webRoute: Routes.profileApplications,
    component: ProfileApplicationsResolver(ProfileApplications),
    title: 'Просмотр заявлений',
  },
];
